var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-420.000000, -687.000000)",
    fill: "#1DBADF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(420.000000, 687.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.27254877,1.18347866 C1.85883393,1.18347866 0.72,2.32629367 0.72,3.73602743 L0.72,15.1996311 C0.72,16.6133459 1.86281501,17.7521798 3.27254877,17.7521798 L14.7361524,17.7521798 C16.1498672,17.7521798 17.2887012,16.6093648 17.2887012,15.1996311 L17.2887012,3.73602743 C17.2887012,2.32231259 16.1458862,1.18347866 14.7361524,1.18347866 L12.3609286,1.17090878 L13.7351592,3.02298354 L14.2413014,3.03555341 C14.9488235,3.03555341 15.5045984,3.63470409 15.5045984,4.3428408 L15.5698984,14.7265219 C15.5698984,15.4340439 15.0000018,16.0045552 14.2918651,16.0045552 L3.89655439,15.9627312 C3.1890323,15.9627312 2.61852109,15.3928346 2.61852109,14.6846979 L2.55322113,4.30101684 C2.55322113,3.59349475 3.12311772,3.02298354 3.83125443,3.02298354 L4.32013282,3.03555341 L5.6016874,1.19604853 L3.27254877,1.18347866 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89195958,11.2430472 L11.9630472,11.2430472 L11.9777107,13.030545 L6.06031741,13.030545 L6.04565395,11.2430472 L8.11674159,11.2430472 L8.11674159,5.91739328 L9.89195958,5.91739328 L9.89195958,11.2430472 Z M9.00435059,0 L12.589531,5.91739328 L5.48865908,5.91739328 L9.00435059,0 Z",
    fillRule: "evenodd"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.a946ca2e.svg";
export { ForwardRef as ReactComponent };